// @flow
import React from "react"
import LoggedOutNav from "./LoggedOutNav"
import LoggedInNav from "./LoggedInNav"
import { MainNavWrap } from "./styled"

type Props = {|
  loggedIn: boolean,
|}

const MainNav = ({ loggedIn }: Props) => (
  <MainNavWrap>{loggedIn ? <LoggedInNav /> : <LoggedOutNav />}</MainNavWrap>
)

export default MainNav



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/index.js